import { ChangeDetectionStrategy,Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatFormField, MatHint, MatLabel, MatPrefix } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { KeysResults } from 'fuzzysort';

import { PageSimpleContentComponent, PageStatus } from 'app/layout/content';
import { FuzzySortResultHighlightComponent } from 'app/shared/fuzzysort-helper/fuzzy-sort-result-highlight.component';
import { emptyFuzzySortOnKeys, executeFuzzySortOnKeys, KeysOfUnion } from 'app/shared/fuzzysort-helper/fuzzysort-helper';
import { Product } from 'app/shared/graph';
import { CopyToClipboardComponent } from 'app/shared/utilities/copy-to-clipboard.component';

import { GitLabUrlBuilder } from './git-lab-url-builder.util';
import { LibraryService } from './library.service';

@Component({
    selector: 'admin-products-page',
    templateUrl: './products-page.component.html',
    styleUrls: ['./products-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PageSimpleContentComponent, MatFormField, MatLabel, MatIcon, MatPrefix, MatInput, FormsModule, MatHint, CopyToClipboardComponent, RouterLink, MatCheckbox, FuzzySortResultHighlightComponent]
})

export class ProductsPageComponent implements OnInit {
    private readonly route = inject(ActivatedRoute);
    private readonly libraryService = inject(LibraryService);
    private readonly gitLabUrlBuilder = inject(GitLabUrlBuilder);

    storeId: string;

    pageStatus: PageStatus = PageStatus.loading;
    pageError?: Error;

    products: Product[] = [];
    filter: string;
    limitShownNumber = true;
    maxResultCount = 200;
    fuzzySearchKeys = ['id', 'label'] as Array<KeysOfUnion<Product>>;
    filteredProducts: KeysResults<Product> = emptyFuzzySortOnKeys();

    constructor() {
        this.storeId = this.route.snapshot.params.storeId;
    }

    ngOnInit(): void {
        this.libraryService.getProducts(this.storeId).subscribe({
            next: (products) => {
                this.products = products;
                this.updateFilter();
                this.pageStatus = PageStatus.loaded;
            },
            error: err => {
                this.pageError = err;
                this.pageStatus = PageStatus.loadError;
            }
        });
    }

    updateFilter() {
        this.filteredProducts = executeFuzzySortOnKeys(
            this.filter || '',
            this.products,
            ['id', 'label'],
            this.limitShownNumber ? this.maxResultCount : Infinity,
        );
    }

    getGitlabLink(productId: string) {
        return this.gitLabUrlBuilder.GetResourceUrl(productId);
    }

    getThumbnailUrlWithStoreId(product: Product): string | undefined {
        if (!product.thumbnail) {
            return undefined;
        }
        let url = new URL(product.thumbnail);
        url.searchParams.append('data-storeId', this.storeId);
        return url.toString();
    }
}
